export default "/fonts/Flaticon2.eot?5971908741f540117ba1d68f2304dd85";